// images import
import img_responsive from "../../public/images/responsive.png";
import img_dynamic from "../../public/images/dynamic.png";
import img_clean from "../../public/images/clean.png";

// images export
export const img_markanjo = require("../../public/images/markanjo.png");

// self introduction data
export const selfIntroData = ["System Engineer", "Web Developer", "Code Lover"];

// self insight data
export const selfInsightData = [
    {
        title: "Responsive",
        desc: `I can develop a system/website that can work on any device, regarding the size.`,
        imgSrc: img_responsive,
        imgAlt: "responsive.png",
    },
    {
        title: "Dynamic",
        desc: `I can develop a system/website that can be fully controlled by it's user.`,
        imgSrc: img_dynamic,
        imgAlt: "dynamic.png",
    },
    {
        title: "Clean",
        desc: `I can develop a system/website that can be easily understood by other programmers as well.`,
        imgSrc: img_clean,
        imgAlt: "clean.png",
    },
];
